<style scoped>
ul,
li,
ol {
  margin: 0px;
  padding: 0px;
  list-style: none;
  font-size: 14px;
}

ul {
  position: relative;
}

ul:before {
  top: 10px;
  position: absolute;
  content: "";
  left: 0px;
  width: 1px;
  border-left: 1px solid #082258;
  bottom: 0px;
}

ul > li {
  line-height: 20px;
}

ul > li > a {
  text-transform: uppercase;
  color: #082258;
  font-weight: bold;
  margin-bottom: 5px;
  display: block;
  position: relative;
  padding-left: 30px;
}

ul > li > a:before {
  content: "";
  position: absolute;
  left: 0px;
  width: 20px;
  height: 2px;
  top: 0px;
  margin: auto;
  bottom: 0px;
  border-bottom: 1px solid #082258;
}

ul > li > a:after {
  width: 5px;
  height: 5px;
  background: #082258;
  position: absolute;
  content: "";
  top: 0px;
  left: 20px;
  bottom: 0px;
  margin: auto;
}

ul ul > li > a:after {
  background: #b9b9b9;
  display: block;
  left: 2px;
}

ul ul > li > a:before {
  content: "";
  position: absolute;
  left: -20px;
  width: 20px;
  height: 2px;
  top: 0px;
  margin: auto;
  bottom: 0px;
  border-bottom: 1px dotted #343434;
}

ul ul:before {
  position: absolute;
  width: 2px;
  border-left: 1px dotted #343434;
  content: "";
  left: 0px;
  top: 0px;
  bottom: 0px;
}

ul ul > li {
  position: relative;
  padding-left: 20px;
}

ul ul > li > a {
  color: #343434;
  display: block;
  text-transform: none;
  position: relative;
  font-weight: normal;
  padding-left: 15px;
  font-size: 14px;
}
</style>

<template>
  <div>
    <li v-for="item in items" :key="item.id">
      <span @click="changeCate(item)">{{ item.org_name }}</span>
      <ul v-if="item.isOpen">
        <list-category :items="getChildren(item.id)"></list-category>
      </ul>
    </li>
  </div>
</template>

<script>
export default {
  name: "ListCategory",
  props: ["items"],
  data() {
    return {
      //   isOpen: false,
    };
  },
  methods: {
    changeCate(cateId) {
      this.$root.$emit("ReportViewerChangeCategory", cateId.value);
    },
    toggleItem(item) {
      //   item.isOpen = !item.isOpen;
      this.$root.$emit("ReportViewerChangeCategory", item.value);
    },
    getChildren(parentID) {
      return this.items.filter((item) => item.pid === parentID);
    },
  },
};
</script>
